import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=54b11e65&"
import script from "./SelectInput.vue?vue&type=script&lang=js&"
export * from "./SelectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b11e65')) {
      api.createRecord('54b11e65', component.options)
    } else {
      api.reload('54b11e65', component.options)
    }
    module.hot.accept("./SelectInput.vue?vue&type=template&id=54b11e65&", function () {
      api.rerender('54b11e65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/v1/renderer/SelectInput.vue"
export default component.exports